// ** Initial State
const initialState = {
  allPosts: [],
  post: null,
  postsDataWithPagintion: {
  "limit": 10,
  "page": 0,
  "total_pages": null,
  "total_records": null,
  "data": null
  },
  pageLoader:true
}

const posts = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_POST':
      return { ...state, allPosts: action.data }
    case 'GET_DATA':
      return { ...state, post: action.data }
    case 'GET_ALL_POST_WITH_PAGINATION':
      return { ...state, postsDataWithPagintion: action.data, pageLoader: false }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
      
    default:
      return { ...state }
  }
}
export default posts
